import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '@3plearning/react-components';
import { ContentText, Footer } from './styled';
import { dismissModal } from '../../containers/modal-manager/modal-manager-actions';

const UnassignModalContent = ({ i18n }) => {
  const dispatch = useDispatch();
  return (
    <Fragment>
      <ContentText>
        {i18n.t`Once a student has started work on an assigned assessment it cannot be unassigned.`}
      </ContentText>
      <ContentText>
        {i18n.t`Changing the assessment type allows you to assign a new set of questions,
      including questions that have previously been assigned. This can help with measuring growth.`}
      </ContentText>
      <Footer>
        <Button
          className="btnOk"
          onClick={() => dispatch(dismissModal())}
          primary
          text={i18n.t`OK`}
          type={Button.LOZENGE} />
      </Footer>
    </Fragment>
  );
};

UnassignModalContent.propTypes = {
  i18n: PropTypes.object
};

export default UnassignModalContent;

